import { render, staticRenderFns } from "./ExpenseCreateForm.vue?vue&type=template&id=55268f2b"
import script from "./ExpenseCreateForm.vue?vue&type=script&lang=js"
export * from "./ExpenseCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports